// Copyright © 2019-2026 Focal Systems. All rights reserved.

import type * as React from "react";

/** Cloud with a plus — used for creating OTA versions. */
export function CloudPlusIcon(props: React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <path d="M12.5 19H9a7 7 0 1 1 6.71-9h1.79a4.5 4.5 0 0 1 4.389 3.5" />
      <path d="M16 19h6" />
      <path d="M19 16v6" />
    </svg>
  );
}
